import { Divider } from "antd";
import React from "react";

const Container = ({ title, children }) => {
  return (
    <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
      {title && (
        <>
          <span className="module-title">{title}</span>
          <Divider />
        </>
      )}
      {children}
    </div>
  );
};

export default Container;
